import { Owners } from "models/applicationUsers";
import { StaffSportsCardOrder } from "models/cards";
import { useAuthenticatedRequestCreator } from "./useRequests";

export interface StaffCardUpdate {
    cardId: string;
    batchId: string;
    owners: Owners;
    salePriceInCents: number;
    title: string;
    status: string;
    listingDate: Date | undefined;
    saleDate: Date | undefined;
    order: StaffSportsCardOrder | undefined;
}

const useSingleCardUpdate = () => {
    const update = useAuthenticatedRequestCreator<boolean, StaffCardUpdate>(
        (card) => {
            const { owners, ...rest } = card;
            return {
                method: "post",
                url: `/cards/update`,
                data: {
                    ...rest,
                    customerIds: owners.customers.map(c => c!.id),
                    accountIds: owners.silentUsers.map(u => u!.accountId)
                },
            };
        }
    );

    return { update };
};

export default useSingleCardUpdate;
